<template>
  <div class="about-page">
    <b-container fluid class="px-4 py-4">

      <!-- Page Title -->
      <div class="page-title-bar">
        <b-icon icon="info-circle-fill" class="mr-2"></b-icon>
        {{ $t('HomePage.aboutus') }}
      </div>

      <b-row class="mt-4">
        <!-- Logo + Title -->
        <b-col md="4" class="mb-4">
          <div class="about-logo-card">
            <b-img :src="require('../assets/laos_logo.png')" fluid class="about-logo"></b-img>
            <h5 class="mt-3 mb-1">ກົມກົງສຸນ</h5>
            <p class="text-muted">Department of Consular Affairs</p>
            <hr>
            <p class="mb-1"><b-icon icon="building" class="mr-2 text-primary"></b-icon> ກະຊວງການຕ່າງປະເທດ</p>
            <p class="mb-1"><b-icon icon="geo-alt-fill" class="mr-2 text-danger"></b-icon> ນະຄອນຫຼວງວຽງຈັນ</p>
            <p class="mb-0"><b-icon icon="globe" class="mr-2" style="color:#002868;"></b-icon> consularlao.gov.la</p>
          </div>
        </b-col>

        <!-- Mission content -->
        <b-col md="8" class="mb-4">
          <div class="about-content-card">
            <div class="about-section-title">ກ່ຽວກັບ ກົມກົງສຸນ</div>
            <p class="about-text">
              ກົມກົງສຸນ ແມ່ນໜ່ວຍງານໃນສັງກັດ ກະຊວງການຕ່າງປະເທດ ແຫ່ງ ສາທາລະນະລັດ ປະຊາທິປະໄຕ ປະຊາຊົນລາວ
              ທີ່ຮັບຜິດຊອບວຽກງານກ່ຽວກັບ ໜັງສືຜ່ານແດນ, ວີຊ່າ ແລະ ການບໍລິການກົງສຸນຕ່າງໆ.
            </p>

            <div class="about-section-title mt-4">ພາລະກິດ</div>
            <div class="mission-list">
              <div class="mission-item">
                <div class="mission-icon">
                  <b-icon icon="check2-circle" font-scale="1.3"></b-icon>
                </div>
                <p>ອອກ ໜັງສືຜ່ານແດນ ໃຫ້ກັບພົນລະເມືອງລາວ</p>
              </div>
              <div class="mission-item">
                <div class="mission-icon">
                  <b-icon icon="check2-circle" font-scale="1.3"></b-icon>
                </div>
                <p>ອໍານວຍຄວາມສະດວກດ້ານວີຊ່າ ແລະ ການເດີນທາງສາກົນ</p>
              </div>
              <div class="mission-item">
                <div class="mission-icon">
                  <b-icon icon="check2-circle" font-scale="1.3"></b-icon>
                </div>
                <p>ໃຫ້ບໍລິການກົງສຸນ ແກ່ ພົນລະເມືອງລາວ ທີ່ຢູ່ໃນຕ່າງປະເທດ</p>
              </div>
              <div class="mission-item">
                <div class="mission-icon">
                  <b-icon icon="check2-circle" font-scale="1.3"></b-icon>
                </div>
                <p>ຮ່ວມມືກັບພາກສ່ວນທີ່ກ່ຽວຂ້ອງໃນການຄຸ້ມຄອງ ແລະ ພັດທະນາ ລະບົບກົງສຸນ</p>
              </div>
            </div>

            <div class="coming-soon-badge mt-3">
              <b-icon icon="clock" class="mr-1"></b-icon>
              ຂໍ້ມູນເພີ່ມເຕີມ ກຳລັງຈະມາເร็ວໆ ນີ້...
            </div>
          </div>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.about-page {
  background: #f4f6fb;
  min-height: 500px;
}
.page-title-bar {
  background: #002868;
  color: #fff;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 1.05rem;
  font-weight: 700;
  border-left: 5px solid #d4af37;
  display: flex;
  align-items: center;
}
.about-logo-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  padding: 28px;
  text-align: center;
}
.about-logo {
  max-width: 120px;
  margin: 0 auto;
  display: block;
}
.about-content-card {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  padding: 28px;
}
.about-section-title {
  font-weight: 700;
  font-size: 1rem;
  color: #002868;
  padding-bottom: 8px;
  border-bottom: 2px solid #d4af37;
  margin-bottom: 14px;
}
.about-text {
  color: #444;
  font-size: 0.92rem;
  line-height: 1.8;
}
.mission-list { display: flex; flex-direction: column; gap: 10px; }
.mission-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #f4f6fb;
  border-radius: 6px;
  padding: 12px 14px;
}
.mission-item p { margin: 0; font-size: 0.9rem; color: #333; }
.mission-icon { color: #002868; flex-shrink: 0; padding-top: 1px; }
.coming-soon-badge {
  display: inline-flex;
  align-items: center;
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
  border-radius: 20px;
  padding: 5px 14px;
  font-size: 0.83rem;
  font-weight: 600;
}
</style>
